module.exports = __webpack_public_path__ + "img/recapBanner-part3.5bd63aff.svg";